/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureEpisode from './patient-procedure-episode';
import PatientProcedureEpisodeDetail from './patient-procedure-episode-detail';
import PatientProcedureEpisodeUpdate from './patient-procedure-episode-update';
import PatientProcedureEpisodeDeleteDialog from './patient-procedure-episode-delete-dialog';

const PatientProcedureEpisodeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureEpisode />} />
    <Route path="new" element={<PatientProcedureEpisodeUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureEpisodeDetail />} />
      <Route path="edit" element={<PatientProcedureEpisodeUpdate />} />
      <Route path="delete" element={<PatientProcedureEpisodeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureEpisodeRoutes;
